import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "nav-menu-nave" }
const _hoisted_2 = { class: "nav-menu-nave__options" }
const _hoisted_3 = { class: "nav-menu-nave__breadcrumb" }
const _hoisted_4 = {
  key: 1,
  class: "nav-menu-nave__beta"
}
const _hoisted_5 = { class: "icon-nav-information" }
const _hoisted_6 = { class: "nav-menu-nave__options" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_account_select = _resolveComponent("account-select")!
  const _component_date_range = _resolveComponent("date-range")!
  const _component_platform_select = _resolveComponent("platform-select")!
  const _component_user_select = _resolveComponent("user-select")!
  const _component_b_container = _resolveComponent("b-container")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_b_container, { class: "nave-c-px-4" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_account_select),
            (_ctx.checkRoute)
              ? (_openBlock(), _createBlock(_component_date_range, {
                  key: 0,
                  time: _ctx.timeOpt,
                  onDateUpdated: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateChart($event)))
                }, null, 8, ["time"]))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$route.meta.breadcrumb), 1),
            (_ctx.checkBeta)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _cache[1] || (_cache[1] = _createElementVNode("span", null, "Versão Beta", -1)),
                  _withDirectives(_createElementVNode("i", _hoisted_5, null, 512), [
                    [
                      _directive_tooltip,
                      
                'Essa é uma versão apta para você usar. Contudo, ainda teremos melhorias a serem implementadas. Qualquer sugestão fale com seu Account.'
              ,
                      void 0,
                      { top: true }
                    ]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_platform_select),
            _createVNode(_component_user_select)
          ])
        ]),
        _: 1
      })
    ])
  ]))
}